<template>
  <v-dialog
      v-model="serviceInfoModal.show"
      max-width="55%"
  >
    <v-card>
      <v-card-title class="headline">
        <h5 class="modal-title p-4 d-inline-block">{{ serviceInfoModal.title }}</h5>
        <v-spacer />
        <v-icon
            aria-label="Close"
            @click="hideServiceInfoModal"
        >
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="2">
            <v-img :src="'/' + serviceInfoModal.image"></v-img>
          </v-col>
          <v-col cols="10">
            {{ serviceInfoModal.content }}
          </v-col>
        </v-row>
        <v-row v-if="serviceInfoModal.description">
          <v-col cols="2">
          </v-col>
          <v-col cols="10">
            {{ serviceInfoModal.description }}
          </v-col>
        </v-row>
        <v-row v-if="serviceInfoModal.duration">
          <v-col cols="2">
          </v-col>
          <v-col cols="3">
            Выполняется:
          </v-col>
          <v-col cols="5">
            {{ toHumanTime(serviceInfoModal.duration) }}
          </v-col>
        </v-row>
        <v-row v-if="serviceInfoModal.warranty_period">
          <v-col cols="2">
          </v-col>
          <v-col cols="3">
            Гарантия:
          </v-col>
          <v-col cols="5">
            {{ serviceInfoModal.warranty_period }} дней
          </v-col>
        </v-row>
        <v-row v-if="serviceInfoModal.paymentInfo">
          <v-col cols="2">
          </v-col>
          <v-col cols="3">
            Условие по ЗП:
          </v-col>
          <v-col cols="5">
            {{ serviceInfoModal.paymentInfo }} %
          </v-col>
        </v-row>
        <v-row class="justify-space-around" v-if="serviceInfoModal.presentation">
          <v-btn @click="openIframe(serviceInfoModal.presentation)">Много интересного...</v-btn>
        </v-row>
        <v-row v-if="serviceInfoModal.traningVideo||serviceInfoModal.techCard">
          <v-col cols="2">
          </v-col>
          <v-col cols="5" v-if="serviceInfoModal.traningVideo">
            <a :href="serviceInfoModal.traningVideo" class="text-blue">Обучение (видео)</a>
          </v-col>
          <v-col cols="5" :disabled="!serviceInfoModal.techCard" class="text-blue">
            <a :href="serviceInfoModal.techCard">Технологичная карта (PDF)</a>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="showIframe"
        max-width="88%"
    >
      <v-card class="fill-height">
        <v-fab-transition>
          <v-btn
              color="pink"
              dark
              absolute
              top
              right
              fab
              class="mt-10"
              @click="showIframe=!showIframe"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-fab-transition>
        <v-card-text class="pa-0 fill-height" style="height: 90vh">
          <iframe :src="iFrameLink" class="frameborder"  width="100%" height="100%"></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      showIframe: false,
      iFrameLink: null,
      tightenCode: '',
      codeEntered: false
    }
  },
  computed: {
    ...mapGetters([
      "order",
      "serviceInfoModal",
      "showServiceInfoModal",
    ]),
  },
  methods: {
    openIframe(url){
      this.showIframe = true
      this.iFrameLink = url
    },
    toHumanTime(milsec){
      return milsec
    },
    hideServiceInfoModal() {
      /* serviceInfoModal: {
              show: false,
              image: null,
              title: null,
              description: null,
              content: null,
              warranty: null,
              warranty_period: null,
              duration: null,
              duration: null,
              duration: null,
          },
      * */
      this.$store.commit('hideServiceInfoModal')
    },
  },
  watch: {
    // needTighten() {},
    enteredCode() {}
  }
}
</script>
<style>
.frameborder {
  border: 2px solid black;
}
</style>
